export default "__VITE_ASSET__rkjYZmGX__"